var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-button',{staticClass:"mr-4",on:{"click":_vm.save}},[_vm._v("Save")])
}
var staticRenderFns = []

export { render, staticRenderFns }